export default __webpack_public_path__ + "static/media/biofit-builder-series-TXG.d23c4c66.png";